import { BillItem } from '../../models/bill-item.model';

export const RECONNECTION_FEE_ITEM_TYPE = 'reconnection_fee';
export const RECONNECTION_FEE_LABEL = 'Cargo por reconexión';

interface ReconnectionFeeSource {
  reconexion_fee?: number | string | null;
}

export function resolveReconnectionFee(
  unit?: ReconnectionFeeSource | null,
  settlement?: ReconnectionFeeSource | null
): number | null {
  const unitFee = normalizeFee(unit?.reconexion_fee);
  if (unitFee !== null) {
    return unitFee;
  }

  return normalizeFee(settlement?.reconexion_fee);
}

export function findActiveReconnectionFee(items?: BillItem[] | null): BillItem | undefined {
  return items?.find(
    item => item.item_type === RECONNECTION_FEE_ITEM_TYPE && !isBillItemCancelled(item)
  );
}

export function isBillItemCancelled(item: BillItem): boolean {
  const cancelled = item.cancelled as unknown;

  if (typeof cancelled === 'string') {
    return cancelled === '1' || cancelled.toLowerCase() === 'true';
  }

  return cancelled === true || cancelled === 1;
}

export function buildReconnectionFeePreviewItem(totalWithTax: number): BillItem {
  const netPrice = roundCurrency(totalWithTax / 1.16);
  const taxAmount = roundCurrency(totalWithTax - netPrice);

  return {
    item_type: RECONNECTION_FEE_ITEM_TYPE,
    quantity: 1,
    price: netPrice,
    net_price: netPrice,
    tax_rate: 0.16,
    tax_amount: taxAmount,
    discount_amount: 0,
    total: roundCurrency(totalWithTax)
  };
}

export function withReconnectionFeeLabel(item: BillItem): BillItem & { description?: string } {
  return item.item_type === RECONNECTION_FEE_ITEM_TYPE
    ? { ...item, description: RECONNECTION_FEE_LABEL }
    : item;
}

export function roundCurrency(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

function normalizeFee(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const fee = Number(value);
  return Number.isFinite(fee) && fee >= 0 ? fee : null;
}
